import React, { useEffect, useState } from "react"
// import { isDesktop } from "react-device-detect"

export default function useReize() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768)
  const [isTablet, setIsTablet] = useState(
    window.innerWidth >= 768 && window.innerWidth < 1024
  )
  useEffect(() => {
    window.addEventListener("resize", resizeHandler)
    return () => window.removeEventListener("resize", resizeHandler)
  }, [])

  useEffect(() => {
    window.addEventListener("orientationchange", orientaionHandler)
    return () =>
      window.removeEventListener("orientationchange", orientaionHandler)
  }, [])

  const resizeHandler = () => {
    if (window.innerWidth < 768) {
      setIsMobile(true)
    } else if (window.innerWidth >= 768 && window.innerWidth < 1024) {
      setIsMobile(false)
      setIsTablet(true)
    } else {
      setIsTablet(false)
      setIsMobile(false)
    }


  }

  const orientaionHandler = () => {
    setTimeout(() => {
      resizeHandler()
    }, 300)
  }

  useEffect(() => {
    resizeHandler()
  }, [])

  return { isMobile, isTablet }
}
